/* Kuji Schnellwahl: 1 / 3 / 5 / 10 / Andere in der Sticky-Bar (mobil).
   Schreibt nur in das bestehende Mengenfeld #Quantity-<section>; kjxrAddToCart liest es wie bisher. */
(function () {
  'use strict';

  var PRESETS = [1, 3, 5, 10];
  var SHEET_MAX = 20;

  function initRoot(root) {
    if (root._kjxrQp) return;
    var qp = root.querySelector('[data-kjxr-qp]');
    var sectionId = root.getAttribute('data-section-id');
    var input = document.getElementById('Quantity-' + sectionId);
    if (!qp || !input) return;
    root._kjxrQp = true;

    var mq = window.matchMedia('(max-width:640px)');
    var price = parseInt(qp.getAttribute('data-price'), 10) || 0;
    var sheet = root.querySelector('[data-kjxr-qpsheet]');
    var grid = sheet && sheet.querySelector('.kjxr-qpgrid');
    var sub = sheet && sheet.querySelector('.kjxr-qpsub');
    var cta = document.getElementById('kjxrAddBtn');
    var leftEl = document.getElementById('kjxrSbLeft');
    var totalEl = document.getElementById('kjxrLoseTotal');
    var bar = root.querySelector('.kjxr-bar');
    var lastFocus = null;

    var left = null;   // Restbestand, sobald die Kuji-API geantwortet hat
    var total = null;

    var mine = null;
    if (bar) {
      mine = document.createElement('span');
      mine.className = 'kjxr-qpmine';
      mine.setAttribute('aria-hidden', 'true');
      bar.appendChild(mine);
    }

    function money(n) {
      return '€' + (n * price / 100).toFixed(2).replace('.', ',');
    }
    function getQty() { return Math.max(1, parseInt(input.value, 10) || 1); }
    function options() {
      var max = left == null ? Infinity : left;
      var o = PRESETS.filter(function (n) { return n <= max; });
      if (left != null && left > 0 && left <= 10 && o.indexOf(left) === -1) o.push(left);
      return o.slice(-4);
    }
    function isAll(n) { return left != null && n === left && left <= 10; }
    function sheetMax() { return Math.max(1, Math.min(SHEET_MAX, left == null ? SHEET_MAX : left)); }

    function renderTiles() {
      var q = getQty();
      var o = options();
      var html = o.map(function (n) {
        var all = isAll(n);
        var unit = n === 1 ? 'Los' : 'Lose';
        return '<button type="button" data-qp="' + n + '"' + (all ? ' class="is-all"' : '')
          + ' aria-pressed="' + (q === n) + '" aria-label="' + (all ? 'Alle ' : '') + n + ' ' + unit + ', ' + money(n) + '">'
          + '<span class="n">' + (all ? 'Alle' : n + '<small>' + unit + '</small>') + '</span>'
          + '<span class="p">' + money(n) + '</span></button>';
      }).join('');
      var custom = o.indexOf(q) === -1;
      html += '<button type="button" class="kjxr-qpmore" data-qp-more aria-haspopup="dialog" aria-pressed="' + custom + '"'
        + ' aria-label="Andere Anzahl wählen">'
        + '<span class="n">' + (custom ? q : 'Andere') + '</span>'
        + '<span class="p">' + (custom ? money(q) : '1–' + sheetMax()) + '</span></button>';
      qp.innerHTML = html;
      qp.setAttribute('aria-disabled', left === 0 ? 'true' : 'false');
    }

    function renderSheet() {
      if (!grid) return;
      var q = getQty(), max = sheetMax(), html = '';
      for (var i = 1; i <= max; i++) {
        html += '<button type="button" data-qp="' + i + '" aria-pressed="' + (q === i) + '">' + i + '</button>';
      }
      grid.innerHTML = html;
      if (sub) {
        sub.textContent = 'Ein Tipp genügt · ' + money(1) + ' pro Los'
          + (left != null && left > SHEET_MAX ? ' · mehr im Warenkorb änderbar' : '');
      }
    }

    function paintCta() {
      if (!cta) return;
      var q = getQty();
      if (!mq.matches || q < 2 || left === 0) { cta.removeAttribute('data-qp-sum'); return; }
      cta.setAttribute('data-qp-sum', q + ' Lose · ' + money(q));
    }

    function paintBar() {
      if (!mine) return;
      var q = getQty();
      if (!mq.matches || !total || left == null || q < 2) { mine.classList.remove('on'); return; }
      var take = Math.min(q, left);
      mine.style.left = ((left - take) / total * 100) + '%';
      mine.style.width = (take / total * 100) + '%';
      mine.classList.add('on');
    }

    function paint() { renderTiles(); paintCta(); paintBar(); }

    function setQty(n) {
      var max = left == null ? Infinity : Math.max(1, left);
      input.value = Math.max(1, Math.min(max, n));
      paint();
    }

    function openSheet() {
      if (!sheet) return;
      renderSheet();
      lastFocus = document.activeElement;
      sheet.classList.add('show');
      sheet.setAttribute('aria-hidden', 'false');
      var cur = grid && grid.querySelector('[aria-pressed="true"]');
      if (cur) cur.focus({ preventScroll: true });
    }
    function closeSheet() {
      if (!sheet || !sheet.classList.contains('show')) return;
      sheet.classList.remove('show');
      sheet.setAttribute('aria-hidden', 'true');
      if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
    }

    qp.addEventListener('click', function (e) {
      var b = e.target.closest('button');
      if (!b) return;
      if (b.hasAttribute('data-qp-more')) { openSheet(); return; }
      setQty(parseInt(b.getAttribute('data-qp'), 10));
    });
    if (sheet) {
      sheet.addEventListener('click', function (e) {
        if (e.target.closest('[data-qp-close]')) { closeSheet(); return; }
        var b = e.target.closest('[data-qp]');
        if (!b) return;
        setQty(parseInt(b.getAttribute('data-qp'), 10));
        setTimeout(closeSheet, 120);
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') closeSheet();
      });
    }

    // Stepper (Tablet/Desktop) und direkte Eingaben synchron halten.
    root.querySelectorAll('[data-kjxr-qty]').forEach(function (b) {
      b.addEventListener('click', function () { setTimeout(paint, 0); });
    });
    input.addEventListener('input', paint);

    // Restbestand aus der bestehenden Anzeige lesen, die kjxr-redesign.js nach dem API-Abruf füllt.
    function readStock() {
      var lt = leftEl ? leftEl.textContent : '';
      var m = lt.match(/\d+/);
      var nextLeft = m ? parseInt(m[0], 10) : (/ausverkauft/i.test(lt) ? 0 : null);
      var tm = totalEl ? totalEl.textContent.match(/\d+/) : null;
      total = tm ? parseInt(tm[0], 10) : total;
      if (nextLeft === left) { paintBar(); return; }
      left = nextLeft;
      if (left != null && left > 0 && getQty() > left) input.value = left;
      paint();
    }
    if (leftEl && 'MutationObserver' in window) {
      new MutationObserver(readStock).observe(leftEl, { childList: true, characterData: true, subtree: true });
    }
    if (mq.addEventListener) mq.addEventListener('change', paint);
    else if (mq.addListener) mq.addListener(paint);

    readStock();
    paint();
  }

  function boot() { document.querySelectorAll('.kjxr[data-section-id]').forEach(initRoot); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
